export default {
	'account-binding': {
		id: 'account-binding',
		label: '账户设置',
		code: '0002_0003'
	}
}
